/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.headerModule')

  .directive('bulbMobileHeaderTabs', bulbMobileHeaderTabs);

function bulbMobileHeaderTabs() {
  return {
    restrict: 'E',
    templateUrl: 'ajs/header/mobileheadertabs.html',
    controller: ['$scope', 'BulbBrowserService', 'BulbPageService',
      function ($scope, BulbBrowserService, BulbPageService) {
        this.page = BulbPageService.page;

        // Foundation must 'reflow' the accordion when groups are added/removed:
        $scope.$watch('mobileHeaderTabsCtrl.page.editing', () => {
          jQuery(document).foundation('accordion', 'reflow');
        });
      }],
    controllerAs: 'mobileHeaderTabsCtrl',
  };
}
